module.exports = __webpack_public_path__ + "static/img/error404.e07be16d.png";